var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "header_wrap" }, [
        _c(
          "div",
          { staticStyle: { width: "60%" } },
          [
            _c(
              "el-steps",
              {
                staticStyle: { width: "100%" },
                attrs: { "align-center": "", active: 0 }
              },
              [
                _c("el-step", { attrs: { title: "海运信息" } }),
                _vm._v(" "),
                _c("el-step", { attrs: { title: "增值服务" } }),
                _vm._v(" "),
                _c("el-step", { attrs: { title: "托运信息" } }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_confirm_order") }
                }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_order_completed") }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "center_wrap" }, [
        _c("div", { staticClass: "wrap_l" }, [
          _c("div", { staticClass: "Item_list" }, [
            _c(
              "div",
              {
                staticClass: "cangkutit",
                staticStyle: { "margin-right": "50px" }
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.cangkuitem.namec) + "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "cangkutit" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.PScangkuitem.namec) + "\n          "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "Item_list" }, [
            _c(
              "div",
              { staticStyle: { width: "100%" } },
              [
                _c(
                  "el-checkbox",
                  {
                    on: { change: _vm.changeTi },
                    model: {
                      value: _vm.tuoCheData.checked,
                      callback: function($$v) {
                        _vm.$set(_vm.tuoCheData, "checked", $$v)
                      },
                      expression: "tuoCheData.checked"
                    }
                  },
                  [_vm._v("发货地上门提货")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tuoCheData.checked,
                    expression: "tuoCheData.checked"
                  }
                ],
                staticStyle: { width: "100%", float: "left" }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      padding: "25px 0 0 25px",
                      "box-sizing": "border-box"
                    }
                  },
                  [
                    _c(
                      "el-form",
                      {
                        attrs: {
                          "label-position": "left",
                          "label-width": "80px",
                          model: _vm.tuoCheData
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.$t("i18n_pickup_location") } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "344px",
                                  height: "36px",
                                  background: "#ffffff",
                                  border: "1px solid #e7e7e7",
                                  "border-radius": "5px"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.changeCheic()
                                  }
                                }
                              },
                              [
                                _c("span", { staticStyle: { float: "left" } }, [
                                  _c("i", {
                                    staticClass: "el-icon-location-outline",
                                    staticStyle: {
                                      "font-size": "16px",
                                      padding: "0 5px"
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      width: "290px",
                                      height: "33px",
                                      overflow: "hidden",
                                      display: "inline-block"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.msgFormSon.parvince) +
                                        _vm._s(_vm.msgFormSon.city) +
                                        _vm._s(_vm.msgFormSon.area) +
                                        _vm._s(_vm.msgFormSon.address)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { float: "right" } },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-arrow-right"
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-form-item", { attrs: { label: "提货日期" } }, [
                          _c(
                            "div",
                            { staticClass: "block" },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "344px" },
                                attrs: {
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd",
                                  type: "date",
                                  placeholder: "选择日期",
                                  "picker-options": _vm.pickerOptions
                                },
                                model: {
                                  value: _vm.todoordate,
                                  callback: function($$v) {
                                    _vm.todoordate = $$v
                                  },
                                  expression: "todoordate"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "Item_list" },
            [
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.changeSh },
                  model: {
                    value: _vm.PSFmoney.checked,
                    callback: function($$v) {
                      _vm.$set(_vm.PSFmoney, "checked", $$v)
                    },
                    expression: "PSFmoney.checked"
                  }
                },
                [_vm._v("目的地送货上门")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.PSFmoney.checked,
                      expression: "PSFmoney.checked"
                    }
                  ],
                  staticStyle: { width: "100%", float: "left" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        padding: "25px 0 0 25px",
                        "box-sizing": "border-box"
                      }
                    },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-position": "left",
                            "label-width": "80px",
                            model: _vm.tuoCheData
                          }
                        },
                        [
                          _c("el-form-item", { attrs: { label: "配送地点" } }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "344px",
                                  height: "36px",
                                  background: "#ffffff",
                                  border: "1px solid #e7e7e7",
                                  "border-radius": "5px"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showPStable()
                                  }
                                }
                              },
                              [
                                _c("span", { staticStyle: { float: "left" } }, [
                                  _c("i", {
                                    staticClass: "el-icon-location-outline",
                                    staticStyle: {
                                      "font-size": "16px",
                                      padding: "0 5px"
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      width: "290px",
                                      height: "33px",
                                      overflow: "hidden",
                                      display: "inline-block"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.msgFormPS.country) +
                                        _vm._s(_vm.msgFormPS.city) +
                                        _vm._s(_vm.msgFormPS.area) +
                                        _vm._s(_vm.msgFormPS.address)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticStyle: { float: "right" } },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-arrow-right"
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "demoLIst" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleform",
                  staticClass: "demo-dynamic",
                  attrs: {
                    "label-width": "58px",
                    "label-position": "left",
                    size: "mini",
                    model: _vm.ruleform
                  }
                },
                _vm._l(_vm.ruleform.formLIst, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "Item_list" },
                    [
                      _c(
                        "el-row",
                        {
                          staticStyle: { "margin-bottom": "15px" },
                          attrs: { gutter: 5 }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "rules",
                                  attrs: {
                                    label: "品名",
                                    prop: "formLIst." + index + ".goodsname",
                                    rules: _vm.moreNotOjb.goodsNotname
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showgoodsType(index)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          attrs: { readonly: "", size: "mini" },
                                          model: {
                                            value: item.goodsname,
                                            callback: function($$v) {
                                              _vm.$set(item, "goodsname", $$v)
                                            },
                                            expression: "item.goodsname"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-arrow-right",
                                            attrs: { slot: "suffix" },
                                            slot: "suffix"
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "rules",
                                  attrs: {
                                    label: "类型",
                                    rules: _vm.moreNotOjb.goodsNotname
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.showgoodsType(index)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          attrs: { readonly: "", size: "mini" },
                                          model: {
                                            value: item.goodstype,
                                            callback: function($$v) {
                                              _vm.$set(item, "goodstype", $$v)
                                            },
                                            expression: "item.goodstype"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-arrow-right",
                                            attrs: { slot: "suffix" },
                                            slot: "suffix"
                                          })
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "rules",
                                  attrs: {
                                    label: "件数",
                                    prop: "formLIst." + index + ".piece",
                                    rules: _vm.moreNotOjb.PRiceNotname
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: { size: "mini" },
                                    on: {
                                      input: function(e) {
                                        return (item.piece = _vm.isSize(e))
                                      }
                                    },
                                    model: {
                                      value: item.piece,
                                      callback: function($$v) {
                                        _vm.$set(item, "piece", _vm._n($$v))
                                      },
                                      expression: "item.piece"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "rules",
                                  attrs: {
                                    label: "重量",
                                    prop: "formLIst." + index + ".weight",
                                    rules: _vm.moreNotOjb.KGNotName
                                  }
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        size: "mini",
                                        min: 0,
                                        max: 999,
                                        placeholder: "请输入重量"
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.getHTFcount(), _vm.getTimoney()
                                        }
                                      },
                                      model: {
                                        value: item.weight,
                                        callback: function($$v) {
                                          _vm.$set(item, "weight", $$v)
                                        },
                                        expression: "item.weight"
                                      }
                                    },
                                    [
                                      _c(
                                        "i",
                                        {
                                          attrs: { slot: "suffix" },
                                          slot: "suffix"
                                        },
                                        [_vm._v("(KG)")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "rules",
                                  attrs: {
                                    label: "体积",
                                    prop: "formLIst." + index + ".cbm",
                                    rules: _vm.moreNotOjb.CBMNotName
                                  }
                                },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      attrs: {
                                        size: "mini",
                                        min: 0,
                                        max: 999,
                                        placeholder: "请输入体积"
                                      },
                                      on: {
                                        change: function($event) {
                                          _vm.getHTFcount(), _vm.getTimoney()
                                        }
                                      },
                                      model: {
                                        value: item.cbm,
                                        callback: function($$v) {
                                          _vm.$set(item, "cbm", $$v)
                                        },
                                        expression: "item.cbm"
                                      }
                                    },
                                    [
                                      _c(
                                        "i",
                                        {
                                          attrs: { slot: "suffix" },
                                          slot: "suffix"
                                        },
                                        [_vm._v("(CBM)")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  item.heavyUnitPrice != "0"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            width: "100%",
                                            "border-radius": "14px",
                                            background: "#f3eac5",
                                            "margin-top": "5px"
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-size": "22rpx",
                                                "font-family": "PingFang SC",
                                                "font-weight": "500",
                                                color: "#9b791e"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      此商品超重，适用重货报价：￥" +
                                                  _vm._s(item.heavyUnitPrice) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("div", { staticClass: "Iteminput" }, [
                              _c(
                                "div",
                                { staticStyle: { "min-width": "56px" } },
                                [_vm._v("尺寸(cm)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          attrs: {
                                            oninput:
                                              "if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}",
                                            size: "mini"
                                          },
                                          model: {
                                            value: item.l,
                                            callback: function($$v) {
                                              _vm.$set(item, "l", $$v)
                                            },
                                            expression: "item.l"
                                          }
                                        },
                                        [
                                          _c(
                                            "i",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                                display: "inline-block"
                                              },
                                              attrs: { slot: "suffix" },
                                              slot: "suffix"
                                            },
                                            [_vm._v("长")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          attrs: {
                                            size: "mini",
                                            oninput:
                                              "if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}",
                                            placeholder: "宽"
                                          },
                                          model: {
                                            value: item.w,
                                            callback: function($$v) {
                                              _vm.$set(item, "w", $$v)
                                            },
                                            expression: "item.w"
                                          }
                                        },
                                        [
                                          _c(
                                            "i",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                                display: "inline-block"
                                              },
                                              attrs: { slot: "suffix" },
                                              slot: "suffix"
                                            },
                                            [_vm._v("宽")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-input",
                                        {
                                          attrs: {
                                            size: "mini",
                                            placeholder: "高",
                                            oninput:
                                              "if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
                                          },
                                          model: {
                                            value: item.h,
                                            callback: function($$v) {
                                              _vm.$set(item, "h", $$v)
                                            },
                                            expression: "item.h"
                                          }
                                        },
                                        [
                                          _c(
                                            "i",
                                            {
                                              staticStyle: {
                                                "margin-top": "5px",
                                                display: "inline-block"
                                              },
                                              attrs: { slot: "suffix" },
                                              slot: "suffix"
                                            },
                                            [_vm._v("高")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    index == _vm.ruleform.formLIst.length - 1,
                                  expression:
                                    "index == ruleform.formLIst.length - 1"
                                }
                              ],
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.addItem("ruleform")
                                }
                              }
                            },
                            [_vm._v("+增加更多")]
                          ),
                          _vm._v(" "),
                          _vm.ruleform.formLIst.length > 1
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { background: "#eeeeee" },
                                  attrs: {
                                    icon: "el-icon-delete",
                                    size: "mini"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleDelete(index, item)
                                    }
                                  }
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wrap_R", class: _vm.auto_fixed ? "auto_fixed" : "" },
          [
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "16px",
                  "font-family": "PingFang SC",
                  "font-weight": "500",
                  color: "#343434"
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("i18n_cost_calculation")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "Item_Right animate__animated animate__bounceInRight"
              },
              [
                _c("p", { staticClass: "tit" }, [_vm._v("海运费")]),
                _vm._v(" "),
                _vm._l(_vm.HYFmoney.goodsTypeFeeDTOS, function(item, index) {
                  return _c("p", { key: index, staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(item.goodsTypeName))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fontString" }, [
                      _vm._v(_vm._s(item.currency) + _vm._s(item.amount))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v("(" + _vm._s(item.calDesc) + ")")
                    ])
                  ])
                }),
                _vm._v(" "),
                _c("p", { staticClass: "coutText" }, [
                  _c("span", { staticClass: "littit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_subtotal")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fontString" }, [
                    _vm._v(
                      _vm._s(_vm.HYFmoney.currency) +
                        _vm._s(_vm.HYFmoney.amount)
                    )
                  ])
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tuoCheData.checked,
                    expression: "tuoCheData.checked"
                  }
                ],
                staticClass:
                  "Item_Right animate__animated animate__bounceInRight"
              },
              [
                _c("p", { staticClass: "tit" }, [
                  _vm._v("提货费 "),
                  _vm.tuoCheData.minKilometer
                    ? _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "13px",
                            float: "right",
                            "font-weight": "500"
                          }
                        },
                        [
                          _vm._v(
                            "(" +
                              _vm._s(_vm.tuoCheData.minKilometer + "KM") +
                              "--" +
                              _vm._s(_vm.tuoCheData.maxKilometer + "KM") +
                              ")"
                          )
                        ]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "coutText" }, [
                  _c("span", { staticClass: "littit" }, [
                    _vm._v("发货地上门提货")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fontString" }, [
                    _vm._v(
                      _vm._s(_vm.tuoCheData.currency) +
                        _vm._s(_vm.tuoCheData.amount)
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.PSFmoney.checked,
                    expression: "PSFmoney.checked"
                  }
                ],
                staticClass:
                  "Item_Right animate__animated animate__bounceInRight"
              },
              [
                _c("p", { staticClass: "tit" }, [_vm._v("配送费")]),
                _vm._v(" "),
                _c("p", { staticClass: "coutText" }, [
                  _c("span", { staticClass: "littit" }, [
                    _vm._v("目的地送货上门")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fontString" }, [
                    _vm._v(
                      _vm._s(_vm.PSFmoney.currency) +
                        _vm._s(_vm.PSFmoney.amount)
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "Item_Right" }, [
              _c(
                "p",
                {},
                [
                  _c("span", { staticClass: "littit" }, [_vm._v("合计费用")]),
                  _vm._v(" "),
                  _vm._l(this.newArray, function(item, index) {
                    return _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.amount > 0,
                            expression: "item.amount > 0"
                          }
                        ],
                        key: index
                      },
                      [
                        _c("span", [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.currency != "",
                                  expression: "item.currency != ''"
                                }
                              ],
                              staticClass: "fontString"
                            },
                            [_vm._v(_vm._s(item.currency))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.amount > 0,
                                  expression: "item.amount > 0"
                                }
                              ],
                              staticClass: "fontString",
                              staticStyle: {
                                "margin-left": "5px",
                                "margin-right": "5px"
                              }
                            },
                            [_vm._v(_vm._s(item.amount))]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  index == _vm.newArray.length - 1
                                    ? false
                                    : true,
                                expression:
                                  "index == newArray.length - 1 ? false : true"
                              }
                            ]
                          },
                          [_vm._v("+")]
                        )
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("p", { staticClass: "coutText" }, [
                _c("span", { staticClass: "littit" }, [_vm._v("折合人民币")]),
                _vm._v(" "),
                _c("span", { staticClass: "fontString" }, [
                  _vm._v("CNY " + _vm._s(_vm.calculatePrice))
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "margin-top": "130px",
                  float: "left"
                }
              },
              [
                _c(
                  "div",
                  { staticStyle: { width: "100%" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        on: {
                          click: function($event) {
                            return _vm.pathToback()
                          }
                        }
                      },
                      [_vm._v("上一步")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { width: "100%", "margin-top": "10px" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          width: "100%",
                          background: "#604aff",
                          color: "#ffffff"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pathToNext("ruleform")
                          }
                        }
                      },
                      [_vm._v("下一步")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "table_wrap",
          attrs: {
            title: "提货地址",
            "modal-append-to-body": false,
            visible: _vm.dialogFormVisible,
            "SonshowType-val": _vm.SonshowType
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "coutn_show" },
            [
              _c("sonComponents", {
                ref: "mychild",
                attrs: {
                  contactype2: _vm.contactype2,
                  tableData: _vm.tableData
                },
                on: { func: _vm.getMsgFormSon }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer header_wrap",
              staticStyle: { height: "35px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-alert", {
                attrs: {
                  title: "点击任意一行选择您的地址",
                  type: "info",
                  center: "",
                  "show-icon": ""
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "收货地址", visible: _vm.dialogTableVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogTableVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                float: "left",
                padding: "15px 15px",
                "box-sizing": "border-box"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "addcalss",
                  on: {
                    click: function($event) {
                      return _vm.addbtn()
                    }
                  }
                },
                [
                  _c("i", {
                    class: !_vm.addType
                      ? "el-icon-circle-plus-outline"
                      : "el-icon-remove-outline"
                  }),
                  _vm._v(
                    "\n        " +
                      _vm._s(!_vm.showType ? "添加地址" : "修改地址") +
                      "\n      "
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("el-collapse-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.addType,
                    expression: "addType"
                  }
                ],
                staticClass: "coutn_show",
                staticStyle: { width: "100%", float: "left" }
              },
              [
                _c(
                  "div",
                  { staticStyle: { padding: "15px", border: "1px solid #33" } },
                  [
                    _c("div", { staticClass: "Iteminput" }, [
                      _c("div", { staticStyle: { "min-width": "60px" } }, [
                        _vm._v("联系人")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              maxlength: 10,
                              "show-word-limit": true,
                              clearable: ""
                            },
                            model: {
                              value: _vm.form.name,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "Iteminput" }, [
                      _c("div", { staticStyle: { "min-width": "60px" } }, [
                        _vm._v("联系方式")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: { maxlength: 13, clearable: "" },
                            model: {
                              value: _vm.form.tel,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "tel", $$v)
                              },
                              expression: "form.tel"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "Iteminput" }, [
                      _c("div", { staticStyle: { "min-width": "60px" } }, [
                        _vm._v("联系地址")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c("el-cascader", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.WaicountLIst,
                              props: _vm.defaultParams
                            },
                            on: { change: _vm.handleChange },
                            model: {
                              value: _vm.shouaddressid,
                              callback: function($$v) {
                                _vm.shouaddressid = $$v
                              },
                              expression: "shouaddressid"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "Iteminput" }, [
                      _c("div", { staticStyle: { "min-width": "60px" } }, [
                        _vm._v("详细地址")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            model: {
                              value: _vm.form.address,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "address", $$v)
                              },
                              expression: "form.address"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "100%",
                      height: "50px",
                      "text-align": "center"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.showType,
                            expression: "!showType"
                          }
                        ],
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.Qdback("I")
                          }
                        }
                      },
                      [_vm._v("确定")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showType,
                            expression: "showType"
                          }
                        ],
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.Qdback("U")
                          }
                        }
                      },
                      [_vm._v("修改")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: {
                          click: function($event) {
                            ;(_vm.addType = false), (_vm.showType = false)
                          }
                        }
                      },
                      [_vm._v("取消")]
                    )
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.addType,
                  expression: "!addType"
                }
              ],
              staticStyle: { width: "100%", float: "left" }
            },
            [
              _c(
                "el-table",
                {
                  ref: "Table",
                  staticStyle: { width: "100%", cursor: "pointer" },
                  attrs: {
                    height: "400",
                    "tooltip-effect": "dark",
                    data: _vm.PStablelist.filter(function(data) {
                      return (
                        !_vm.searchPSname ||
                        data.name
                          .toLowerCase()
                          .includes(_vm.searchPSname.toLowerCase())
                      )
                    }),
                    "highlight-current-row": "",
                    border: ""
                  },
                  on: { "row-click": _vm.getCurrentRow }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "姓名",
                      width: "100",
                      align: "center",
                      prop: "name"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "电话",
                      width: "120",
                      align: "center",
                      prop: "tel"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "联系地址",
                      "show-overflow-tooltip": "",
                      align: "center"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.country) +
                                "\n            " +
                                _vm._s(scope.row.city) +
                                "\n            " +
                                _vm._s(scope.row.area) +
                                "\n            " +
                                _vm._s(scope.row.address) +
                                "\n          "
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { align: "center", width: "160" },
                    scopedSlots: _vm._u([
                      {
                        key: "header",
                        fn: function(scope) {
                          return [
                            _c("el-input", {
                              attrs: {
                                size: "mini",
                                placeholder: "请输入姓名"
                              },
                              model: {
                                value: _vm.searchPSname,
                                callback: function($$v) {
                                  _vm.searchPSname = $$v
                                },
                                expression: "searchPSname"
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.handleEdit(
                                      scope.$index,
                                      scope.row
                                    )
                                  }
                                }
                              },
                              [_vm._v("编辑")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.delpsItem(
                                      scope.$index,
                                      scope.row
                                    )
                                  }
                                }
                              },
                              [_vm._v("删除")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer header_wrap",
              staticStyle: { height: "35px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-alert", {
                attrs: {
                  title: "点击任意一行选择您的地址",
                  type: "info",
                  center: "",
                  "show-icon": ""
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "goodsTypeShow",
          attrs: { visible: _vm.goodsTypeShow },
          on: {
            "update:visible": function($event) {
              _vm.goodsTypeShow = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "30px 0" } },
            [
              _c(
                "el-tabs",
                { attrs: { "tab-position": "left" } },
                _vm._l(_vm.tabbar, function(item, index) {
                  return _c(
                    "el-tab-pane",
                    {
                      key: index,
                      staticStyle: { color: "red" },
                      attrs: { label: item.namec }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "16px",
                            "font-family": "PingFang SC",
                            "font-weight": "bold",
                            color: "#333333",
                            "margin-bottom": "11px"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.namec) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(item.datItemInfoDTOList, function(_item, _index) {
                        return _c(
                          "div",
                          {
                            key: _index,
                            staticStyle: {
                              float: "left",
                              "margin-right": "5px"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  size: "mini",
                                  type: "info",
                                  plain: ""
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.changeGoodstype(_item, index)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_item.namec))]
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                }),
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "cangkutit", staticStyle: { "margin-right": "50px" } },
      [
        _c("img", {
          staticStyle: { width: "60px" },
          attrs: { src: require("../../assets/setIcon.png"), alt: "" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3788bb52", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3788bb52","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/placeOrder/bulkCargo.vue
// module id = null
// module chunks = 